import { AppointmentDetailPage } from '../appointment/pages/appointment-detail/AppointmentDetailPage'
import { EncounterDetailPage } from '../encounter/pages/encounter-detail/EncounterDetailPage'
import { TimelineRoot } from './pages/timeline-root'

import type { RouteObject } from 'react-router-dom'

const timelineRoutes: RouteObject[] = [
  {
    path: 'timeline',
    element: <TimelineRoot />,
    children: [
      {
        path: 'appointment/:id',
        element: <AppointmentDetailPage />,
      },
      {
        path: 'encounter/:id',
        element: <EncounterDetailPage />,
      },
    ],
  },
]

export { timelineRoutes }
